module.exports = __webpack_public_path__ + "img/SWP_Axe_2H_01.3264a3fd.png";